import { isGuid } from '@experiences/util';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const invalidOrganizationNames = [ 'portal_', 'host' ];

export default function useAuthParams() {
    const location = useLocation();

    const [ organizationId, organizationName ] = useMemo(() => {
        const searchParams = new URLSearchParams(location.search);
        const path = location.pathname.split('/');
        return [ searchParams.get('organizationId'), path[1] ];
    }, [ location.search, location.pathname ]);

    const authParams = useMemo(() => {
        const params: any = {};

        const acr_values =
      organizationId && isGuid(organizationId)
          ? `tenant:${organizationId}`
          : organizationName && invalidOrganizationNames.indexOf(organizationName) === -1
              ? `tenantName:${organizationName}`
              : undefined;

        if (acr_values) {
            params.acr_values = acr_values;
        }

        return {
            ...params,
            state: { returnTo: location.pathname + location.search },
        };

    }, [ organizationName, organizationId, location ]);

    return authParams;
}
